/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState, useEffect } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Stack,
  Checkbox
} from '@chakra-ui/react'

const EditModal = ({
  aiStrategies,
  isOpen,
  item,
  onClose,
  onSave
}) => {
  const [formData, setFormData] = useState({
    title: '',
    preDealAIStrategies: ''
  })
  const options = aiStrategies
    ?.filter(
      strategy => strategy
        ?.supportedFileTypes
        ?.includes(item?.fileType)
    )
    ?.map(strategy => ({
      id: strategy.id,
      name: strategy.name
    })) ?? []

  useEffect(() => {
    if (item) {
      setFormData({
        title: item.title || '',
        preDealAIStrategies: item.preDealAIStrategies || '',
        separateIngredients: item.separateIngredients
      })
    }
  }, [item])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value
    })
  }

  const onSeparateIngredientsChange = (e) => {
    setFormData({
      ...formData,
      separateIngredients: e.target.checked
    })
  }

  const handleSubmit = () => {
    const updatedItem = { ...item, ...formData }
    onSave(updatedItem)
  }

  if (!item) return null

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Asset</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack spacing={4}>
            <FormControl>
              <FormLabel>AI METADATA TITLE</FormLabel>
              <Input
                disabled
                name="title"
                value={formData.title}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl>
              <FormLabel>AI STRATEGIES</FormLabel>
              <Select
                name="preDealAIStrategies"
                value={formData.preDealAIStrategies}
                onChange={handleChange}
                placeholder="Select AI Strategy"
              >
                {options?.map((option) => (
                  <option
                    value={option.id}
                    key={`strategy-option-${option.id}`}
                  >
                    { option.name }
                  </option>
                ))}
              </Select>
            </FormControl>
            { item.fileType === 'PDF' &&
              <FormControl>
                <FormLabel>INGREDIENT AI METADATA</FormLabel>
                <Checkbox
                  size="lg"
                  onChange={onSeparateIngredientsChange}
                  isChecked={formData.separateIngredients}
                >
                  Separate Ingredient AI Metadata
                </Checkbox>
              </FormControl>
            }
          </Stack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSubmit}>
            Save Changes
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default EditModal
